<!--设备的详情组件-->
<template>
  <div class="deviceParameter">
    <h2 class="myplant">参数</h2>
    <el-main class="plantmiddel">
      <ul>
        <li>软件版本号：{{ curDeviceOnline ? curDeviceData.fwVersion :''}}</li>
        <li>固件版本号：{{ curDeviceOnline ? curDeviceData.hwVersion :''}}</li>
        <li>驱动程序版本号：{{ curDeviceOnline ? curDeviceData.drVersion :''}}</li>
        <!-- <li>办卡所使用的中断号：{{ curDeviceData.boardCardStopNum }}</li> -->
        <li>硬件序列号：{{ curDeviceOnline ? curDeviceData.sn :''}}</li>
        <li>硬件类型：{{ curDeviceOnline ? curDeviceData.hwType :''}}</li>
        <li>运行时间：{{ curDeviceOnline ? runTime :'' }}</li>
        <!--        <li>最大内存：{{curDeviceData.maxMemory}}</li>-->
        <!--        <li>已用内存：{{curDeviceData.useMemory}}</li>-->
      </ul>
    </el-main>
    <el-main :class="'configTable'">
      <h2>设备配置</h2>
      <table class="config-table">
        <thead>
        <tr>
          <th>配置项</th>
          <th>值</th>
        </tr>
        </thead>
        <tbody class="el-table__body">
        <tr>
          <td>不自动休眠</td>
          <td>
            <template>
              <!-- `checked` 为 true 或 false -->
              <el-checkbox v-model="isDormancy" @change="setDeviceConfig(curDeviceData.id)"
                           :disabled="!curDeviceOnline"></el-checkbox>
            </template>
          </td>
        </tr>
        <tr>
          <td>文件自动上传</td>
          <td>
            <template>
              <!-- `checked` 为 true 或 false -->
              <el-checkbox v-model="autoUploadFile" @change="setDeviceConfig(curDeviceData.id)"
                           :disabled="!curDeviceOnline"></el-checkbox>
            </template>
          </td>
        </tr>
        <tr>
          <td>Wi-Fi下自动上传</td>
          <td>
            <template>
              <!-- `checked` 为 true 或 false -->
              <el-checkbox v-model="wfAutoUploadFile" @change="setDeviceConfig(curDeviceData.id)"
                           :disabled="!curDeviceOnline"></el-checkbox>
            </template>
          </td>
        </tr>
        </tbody>
      </table>
    </el-main>
    <el-main :class="'configTable'">
      <h2>文件录制状态</h2>
      <table class="config-table">
        <thead>
        <tr>
          <th>配置项</th>
          <th>状态信息</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody class="el-table__body">
        <tr>
          <td style="width: 35%">自启动录制</td>
          <td>{{curDeviceData.deviceFileRocVO.autoRoc ? 'Y' : 'N'}}</td>
          <td style="width: 250px">
            <template>
              <el-button @click="setRocStatus(false)" v-if="curDeviceData.deviceFileRocVO.autoRoc"
                         icon="el-icon-circle-check" type="danger" size="small" round>取消自启动录制
              </el-button>
              <el-button @click="setRocStatus(true)" v-else
                         icon="el-icon-circle-check" type="primary" size="small" round>自启动录制
              </el-button>
            </template>
          </td>
        </tr>
        <tr>
          <td>触发条件</td>
          <td>{{curDeviceData.deviceFileRocVO.condition ? 'Y' : 'N'}}</td>
          <td>
            <template>
              <el-button @click="clearConditionConfig" :disabled="!curDeviceData.deviceFileRocVO.condition"
                         icon="el-icon-circle-check" type="primary" size="small" round>清除配置
              </el-button>
            </template>
          </td>
        </tr>
        <tr>
          <td>录制文件类型</td>
          <td>{{curDeviceData.deviceFileRocVO.rocAsc ? 'Asc' : ''}} {{curDeviceData.deviceFileRocVO.rocBlf ? 'Blf' :
            ''}} {{curDeviceData.deviceFileRocVO.rocDat ? 'Dat' : ''}}
          </td>
        </tr>
        </tbody>
      </table>
    </el-main>
    <el-main class="passageway">
      <h2>通道 ({{ curDeviceData.canDatas ? curDeviceData.canDatas.length : '-' }}个)</h2>
      <div class="passage">
        <el-table :data="curDeviceOnline ? curDeviceData.canDatas :[]" style="width: 100%;">
          <el-table-column
            prop="name"
            fixed
            label="通道"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="baudRate"
            label="波特率"
            min-width="120">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="status-dot"
                   :class="{'status-free': scope.row.status === 0,'status-running': scope.row.status === 1,'status-error': scope.row.status === -1}">
              </div>
              <span>
                {{scope.row.status === 0 ? 'Free' : (scope.row.status === 1 ? 'Running' : 'Error')}}
              </span>
            </template>
          </el-table-column>
          // TODO: SUN Hao 2019/4/2 11:18 待增加真实的录制状态接口
          <el-table-column label="录制中">
            <template slot-scope="scope">
              <div class="status-dot"
                   :class="{'status-free': scope.row.status === 0,'status-running': scope.row.status === 1,'status-error': scope.row.status === -1}">
              </div>
              <span>
                {{scope.row.play === false ? 'No' : (scope.row.play === true  ? 'Yes' : 'Error')}}
                <!--                  {{scope.row.dataUpload}}-->
              </span>
            </template>
          </el-table-column>
          <el-table-column label="上传数据">
            <template slot-scope="scope">
              <div class="status-dot"
                   :class="{'status-free': scope.row.status === 0,'status-running': scope.row.status === 1,'status-error': scope.row.status === -1}">
              </div>
              <span>
                {{scope.row.dataUpload === false ? 'No' : (scope.row.dataUpload === true ? 'Yes' : 'Error')}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button @click="startPlay(curDeviceData.id,scope.row.name)"
                         v-show="!scope.row.play" icon="el-icon-circle-check" type="primary" size="small" round>开始录制
              </el-button>
              <el-button @click="stopPlay(curDeviceData.id,scope.row.name)" style="margin: 0px"
                         v-show="scope.row.play" icon="el-icon-remove-outline" type="danger" size="small" round>停止录制
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <el-main class="fota-file-list">
      <h2>OTA升级列表</h2>
      <div class="file-list-table">
        <div class="device-fota">
          <h3>Device FOTA</h3>
          <el-button class="upload-file-btn" @click="showUploadFirmwareDialog" type="primary" plain size="small"
                     :disabled="!curDeviceOnline">上传固件
            <i class="el-icon-upload"></i></el-button>
          <el-table :data="curDeviceOnline ? FotaOptions :[]">
            <el-table-column prop="name" label="固件名" fixed min-width="150px"></el-table-column>
            <el-table-column prop="createTime" label="创建日期" sortable width="200px"></el-table-column>
            <el-table-column prop="length" label="固件大小" min-width="100px"></el-table-column>
            <el-table-column prop="verifyStatus" label="校验结果" min-width="100px"></el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button class="buttons" @click="downloadToDeviceClick(scope.row.id)"
                           type="primary" size="small" round>
                  开始刷新
                </el-button>
                <el-button class="buttons" @click="deleteFile(scope.row.id)"
                           icon="el-icon-delete" type="danger" size="small" round>删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-progress :percentage="100" color="#7ABBE9" style="margin-top: 20px;margin-bottom: 40px"></el-progress>
        </div>
        <div class="ecu-flash">
          <h3>ECU OTA</h3>
          <el-button class="upload-file-btn" type="primary" plain size="small" @click="startOTA"
                     :disabled="!curDeviceOnline">开始刷写
            <i class="el-icon-edit-outline"></i></el-button>
          <!--          <el-button class="upload-file-btn" type="primary" plain size="small" @click="getOTAConfig">获取配置-->
          <!--            <i class="el-icon-receiving"></i></el-button>-->
<!--          <el-table :data="curDeviceOnline ? curDeviceData.canDatas :[]" style="width: 100%;text-align: center"-->
          <el-table :data="curDeviceOnline ? otacurDeviceData :[]" style="width: 100%;text-align: center"
                    highlight-current-row
                    @current-change="handleSelectionChange"
                    ref="multipleTable">
            <el-table-column
              prop="name"
              fixed
              label="通道"
              min-width="100">
            </el-table-column>
            <el-table-column
              label="绑定s19/srec"
              min-width="150">
              <template slot-scope="scope">
                <el-select v-model="s19BindList[scope.$index]" size="mini" placeholder="未绑定">
                  <el-option
                    v-for="item in s19FileOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="绑定so"
              min-width="150">
              <template slot-scope="scope">
                <el-select v-model="soBindList[scope.$index]" size="mini" placeholder="未绑定">
                  <el-option
                    v-for="item in soFileOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="绑定密匙"
              min-width="150">
              <template slot-scope="scope">
                <el-select v-model="dllBindList[scope.$index]" size="mini" placeholder="未绑定">
                  <el-option
                    v-for="item in dllFileOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="波特率"
              min-width="150">
              <template slot-scope="scope">
                <el-select v-model="OTABaudRate[scope.$index]" size="mini" placeholder="请选择波特率">
                  <el-option
                    v-for="(item, index) in baudRateArr"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="操作"
              width="250">
              <template slot-scope="scope">
                <el-button type="primary" size="small" round @click="saveOTAConfig(scope.$index)">
                  <i class="el-icon-document-checked"></i> 保存配置
                </el-button>
                <el-popover
                  placement="right"
                  width="800"
                  trigger="click">
                  <el-table :data="otaHistory"
                            :default-sort="{prop: 'startTime', order: 'descending'}">
                    <el-table-column
                      type="index"
                      width="50">
                    </el-table-column>
                    <el-table-column prop="s19Name" label="文件名" min-width="150px"></el-table-column>
                    <el-table-column prop="startTime" label="开始时间" sortable width="200px"></el-table-column>
                    <el-table-column prop="stopTime" label="结束时间" min-width="100px"></el-table-column>
                    <el-table-column prop="otaStatus" label="状态" min-width="100px"></el-table-column>
                  </el-table>
                  <el-button type="primary" size="small" slot="reference" round @click="getOTAHistory(scope.$index)">
                    <i class="el-icon-notebook-1"></i> 查看历史
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-progress :percentage="getOTAProgress*1" color="#7ABBE9" style="margin-top: 20px;" v-show="!ErrorMsg"></el-progress>
          <el-progress :percentage="100" color="#F56C6C" style="margin-top: 20px;" v-show="ErrorMsg"></el-progress>
          <div font-family="PingFang SC" style="font-size: 15px;color: #F56C6C;text-align: center" v-show="ErrorMsg">{{ErrorMsg}}</div>
        </div>
      </div>
    </el-main>

    <el-main :class="'device-file-list'">
      <h2>设备文件列表</h2>
      <el-button class="refresh-file-btn" @click="checkFileListUpdate" type="primary" plain size="small"
                 :disabled="!curDeviceOnline">刷新文件
        <i class="el-icon-refresh"></i></el-button>
      <el-button class="upload-file-btn" @click="showUploadFileDialog" type="primary" plain size="small"
                 :disabled="!curDeviceOnline">上传文件
        <i class="el-icon-upload"></i></el-button>
      <div class="file-list-table">
        <el-container style="width: 100%">
          <el-main style="padding: 0 10px">
            <el-container style="width: 100%;height: 50px">
              <el-aside width="220px" style="padding: 0">
                <h3 style="height: 20px" class="progress-title">
                  <i class="el-icon-mobile-phone" style="font-size: 30px"/>{{curDeviceOnline ? curDeviceData.useMemory :
                  '0B'}}/{{curDeviceOnline ? curDeviceData.maxMemory : '0B'}}
                </h3>
              </el-aside>
              <el-main style="padding: 10px 0 0 0">
                <div v-show="progressShow">
                  <el-progress :percentage="curDeviceOnline ? memoryProgress : 0" status="exception"
                               class="progress-bar"></el-progress>
                </div>
                <div v-show="!progressShow">
                  <el-progress color="#7ABBE9" :percentage=" curDeviceOnline ? memoryProgress :0"
                               class="progress-bar"></el-progress>
                </div>
              </el-main>
            </el-container>
          </el-main>
          <el-aside style="width:50%;padding:0 10px">
            <el-container style="width: 100%;height: 50px">
              <el-aside width="220px" style="padding: 0">
                <h3 style="height: 20px;" class="progress-title">
                  <i class="el-icon-files" style="font-size: 30px"></i> {{curDeviceOnline ? curDeviceData.useMemory :
                  '0B'}} / {{curDeviceOnline ? curDeviceData.maxMemory : '0B'}}</h3>
              </el-aside>
              <el-main style="padding: 10px 0 0 0">
                <div v-show="UprogressShow">
                  <el-progress :percentage="UmemoryProgress" status="exception"
                               class="progress-bar"></el-progress>
                </div>
                <div v-show="!UprogressShow">
                  <el-progress color="#7ABBE9" :percentage="UmemoryProgress"
                               class="progress-bar"></el-progress>
                </div>
              </el-main>
            </el-container>
          </el-aside>
        </el-container>
        <div class="batch-button">
          <el-button type="primary" plain size="small" round v-show="showBatchDownload" @click="batchDownload">批量下载
          </el-button>
          <el-button type="success" size="small" round plain v-show="showBatchUpload" @click="batchUpload">批量上传
          </el-button>
          <el-button type="warning" size="small" round plain v-show="showBatchBlf" @click="batchConvertBLF">批量转blf
          </el-button>
          <el-button type="danger" size="small" round plain v-show="showBatchDelete" @click="batchDelete">批量删除
          </el-button>
        </div>
        <el-pagination class="page-divided"
                       layout="prev, pager, next"
                       @current-change="dividePage"
                       :page-size="8"
                       :page-count="2"
                       :total="total">
        </el-pagination>

        <!--设备文件列表中不再显示java文件,对应commonFileList-->
        <!--          :data="commonFileList.slice((currentPage-1)*pageSize,currentPage*pageSize)"-->
        <el-table
          ref="fileTable"
          :data=" curDeviceOnline ? curFileList :[]"
          @selection-change="handleFileSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="name" label="文件名" fixed min-width="180px"></el-table-column>
          <el-table-column prop="name" label="类型" fixed min-width="50px">
            <template slot-scope="scope">
              <span>{{scope.row.name.split('.')[1]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期" width="140px"></el-table-column>
          <el-table-column prop="length" label="文件大小" min-width="80px"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="100px">
            <template slot-scope="scope">
              <!--<div>{{scope.row.status}},{{scope.row.status === DEVICE_FILE_STATUS.ONDEVICE}}</div>-->
              <span v-if="scope.row.status === DEVICE_FILE_STATUS.ONSD">
                在内存卡中
              </span>
              <span v-if="scope.row.status === DEVICE_FILE_STATUS.ONUDISK">
                在U盘中
              </span>
              <span v-if="scope.row.status === DEVICE_FILE_STATUS.ONSERVER">
                在服务器上
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button-group>
                <el-button class="buttons" v-if="scope.row.status!==DEVICE_FILE_STATUS.ONSERVER"
                           type="success" size="small" round
                           @click="uploadToServer(scope.row.id),uploadProgress(scope.row)">
                  <!--                  uploadStatus(scope.row,scope.$index)-->
                  上传服务器
                </el-button>
                <el-button v-else class="buttons" @click="downloadClick(scope.row.id)" type="primary" size="small"
                           round>
                  下载至本地
                </el-button>
                <el-button class="buttons"
                           v-if="scope.row.status===DEVICE_FILE_STATUS.ONSERVER && isAsc(scope.row.name)"
                           @click="changeFileAscToBlf(scope.row.id)" type="primary" size="small" round>
                  转为blf格式
                </el-button>
              </el-button-group>
              <el-button class="buttons" @click="deleteFile(scope.row.id)"
                         icon="el-icon-delete" type="danger" size="small" round>删除
              </el-button>
              <!--              <el-progress type="line" color="#7ABBE9" style="margin-top:10px" v-show="checkFileId(scope.row.id)"-->
              <!--                           :percentage="getPercentage(scope.row.name)"></el-progress>-->
              <!--              <el-progress type="line" color="#7ABBE9" style="margin-top:10px"-->
              <!--                           :percentage="getFileUploadPercentage(scope.row.id)"></el-progress>-->
              <!--用el-progress会出现数据变了，进度条却渲染不上的情况-->
              <div v-show="checkFileId(scope.row.id, scope.row.status)">
                <progress :value="getFileUploadPercentage(scope.row.id)" max="100" style="width: 80%"/>
                <span>{{getFileUploadPercentage(scope.row.id)}}%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <!--通道绑定-->
    <el-dialog :title="`上传FOTA固件至服务器`"
               :visible.sync="uploadFirmwareToServerVisible"
               width="400px"
               top="30vh">
      <el-upload
        action="/"
        class="upload-demo"
        drag
        :limit="1"
        :on-exceed="handleFileCountExceed"
        ref="uploadFileCmp"
        :http-request="uploadFirmware">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <div>将文件拖到此处，或<em>点击上传</em></div>
          <div>请上传用于FOTA的最新固件</div>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadFirmwareToServerClick">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`上传文件至服务器`"
               :visible.sync="uploadFileToServerVisible"
               width="400px"
               top="30vh">
      <el-upload
        action="/"
        class="upload-demo"
        drag
        :limit="1"
        :on-exceed="handleFileCountExceed"
        ref="uploadFileCmp"
        :http-request="uploadFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <div>将文件拖到此处，或<em>点击上传</em></div>
          <div>支持任意文件格式。注意：.dat、.mdf作为采集文件；</div>
          <div>.s19/.srec、.so、.dll文件将用于ECU OTA</div>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadFileToServerClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { DEVICE_FILE_STATUS, DEVICE_NET_STATUS } from '@/common/enums';
import deviceAPI from '@/api/device';

export default {
  name: 'deviceParameter',
  inject: ['reload'],
  data: () => (
    {
      OTABaudRate: ['500', '500', '500'],
      percentage: [],
      colors: [{ color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 },
      ],
      DEVICE_FILE_STATUS,
      DEVICE_NET_STATUS,
      bindPassagewayDialogVis: false,
      isDormancy: false,
      autoUploadFile: false,
      wfAutoUploadFile: false,
      /**
         * 是否打开上传文件的窗口
         */
      uploadFileToServerVisible: false,
      uploadFirmwareToServerVisible: false,
      uploadS19ToServerVisible: false,
      uploadDllToServerVisible: false,
      // 每页的数据条数
      pageSize: 8,
      // 默认开始页面
      currentPage: 1,
      s19BindList: [],
      soBindList: [],
      dllBindList: [],
      otaIdList: [],
      selectedOTA: [],
      // 4G通知状态，避免重复通知
      fourGInformed: false,
      otaHistory: [
        {
          s19Name: '1.s19',
          startTime: '2019-05-29 21:24:25',
          stopTime: '2019-05-29 21:24:25',
          otaStatus: '成功',
        },
        {
          s19Name: '2.s19',
          startTime: '2019-05-29 21:34:25',
          stopTime: '2019-05-29 21:35:25',
          otaStatus: '失败',
        },
      ],
      // uploadingList: [],
      // isUploading: false,

      // 文件多选列表相关
      multipleSelection: [],
      showBatchDownload: false,
      showBatchUpload: false,
      showBatchDelete: false,
      showBatchBlf: false,
      baudRateArr: [
        { label: '5Kbps', value: '5' },
        { label: '10Kbps', value: '10' },
        { label: '20Kbps', value: '20' },
        { label: '40Kbps', value: '40' },
        { label: '50Kbps', value: '50' },
        { label: '80Kbps', value: '80' },
        { label: '100Kbps', value: '100' },
        { label: '125Kbps', value: '125' },
        { label: '200Kbps', value: '200' },
        { label: '250Kbps', value: '250' },
        { label: '400Kbps', value: '400' },
        { label: '500Kbps', value: '500' },
        { label: '666Kbps', value: '666' },
        { label: '800Kbps', value: '800' },
        { label: '1000Kbps', value: '1000' },
      ],
    }),
  mounted() {
    if (this.deviceId !== '') {
      this.getOTAConfig();
    }
  },
  computed: {
    ...mapState('Device', ['curDeviceData', 'curDeviceOnline']),
    ...mapGetters('Device', ['deviceFileList', 'getRefreshResult', 'getDeviceConfig', 'getuploadingList', 'getisUploading', 'getotaErrorMsg']),
    // 正在上传的文件列表
    // 以下两个数据换为存到vuex里，以便于自动上传文件时，点击设备获取进度条和上传状态
    otacurDeviceData() {
      const otacurDeviceData = this.curDeviceData.canDatas.filter(ele => ele.canType === 0);
      return otacurDeviceData;
    },
    uploadingList() {
      return this.getuploadingList;
    },
    // 是否正在上传
    isUploading() {
      return this.getisUploading;
    },
    ErrorMsg() {
      return this.getotaErrorMsg;
    },
    runTime() {
      const time = this.curDeviceData.runTime;
      if (time === undefined) {
        return '';
      }
      return `${Math.floor(time / 86400)}天${Math.floor((time % 86400) / 3600)}时${Math.floor((time % 3600) / 60)}分`;
    },
    curDeviceConfig() {
      if (this.getDeviceConfig === undefined) {
        return {};
      }
      return this.getDeviceConfig;
    },
    commonFileList() {
      return this.deviceFileList.filter(item => !((item.name.indexOf('.jar') > -1)));
    },
    FotaOptions() {
      return this.deviceFileList.filter(item => ((item.name.indexOf('.jar') > -1) || (item.name.indexOf('.c')) > -1));
    },
    total() {
      return this.commonFileList.length;
    },
    soFileOptions() {
      return this.deviceFileList.filter(item => ((item.name.indexOf('.so') > -1) || (item.name.indexOf('.SO')) > -1));
    },
    dllFileOptions() {
      return this.deviceFileList.filter(item => ((item.name.indexOf('.dll') > -1) || (item.name.indexOf('.DLL')) > -1));
    },
    s19FileOptions() {
      return this.deviceFileList.filter(item => ((item.name.indexOf('.s19') > -1) || (item.name.indexOf('.S19') > -1) || (item.name.indexOf('.srec') > -1) || (item.name.indexOf('.SREC') > -1)));
    },
    memoryProgress() {
      return this.curDeviceData.percentage;
    },
    progressShow() {
      return this.curDeviceData.percentage > 85;
    },
    UmemoryProgress() {
      return this.curDeviceData.uDiskPercentage;
    },
    UprogressShow() {
      return this.curDeviceData.uDiskPercentage > 85;
    },
    curFileList() {
      return this.commonFileList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    deviceId() {
      const id = this.curDeviceData.id;
      if (id === undefined) {
        return '';
      }
      return id;
    },
    // OTA进度
    getOTAProgress() {
      return this.$store.getters.getOTAProgress;
    },
    // OTA成功
    getOTASuccess() {
      return this.$store.getters.getOTASuccess;
    },
    // 文件上传进度
    getFileUploadProgress() {
      return this.$store.getters.getFileUploadProgress;
    },
  },
  methods: {
    ...mapMutations('Device', ['setOtaStatus', 'setSearchVal', 'setDeviceIndex', 'setuploadingList', 'setisUploading', 'setotaErrorMsg']),
    ...mapActions('Device', {
      api_deleteFile: 'deleteFile',
      checkUpdate: 'checkFileListUpdate',
      refreshCurDeviceFileList: 'refreshCurDeviceFileList',
      otaSubscription: 'otaSubscription',
      otaUnsubscription: 'otaUnsubscription',
      uploadProgressSubscription: 'uploadProgressSubscription',
      uploadProgressUnsubscription: 'uploadProgressUnsubscription',
      otaErrorMsgSubscription: 'otaErrorMsgSubscription',
      otaErrorMsgUnsubscription: 'otaErrorMsgUnsubscription',
      getOTAProgressData: 'getOTAProgressData',
    }),
    //  上传服务器状态显示
    uploadStatus(row, rowIndex) {
      // 打开上传状态显示
      const self = this;
      const name = row.name;
      const id = row.id;

      function circle() {
        self.isUploading = true;
        let index = self.percentage.indexOf(name);
        if (!(index > -1)) {
          index = self.percentage.length;
          self.percentage.push(name);
        }
        deviceAPI.getFileProcess(name)
          .then(
            (res) => {
              self.percentage[index + 1] = res[0].per;
              // 接着判断上传状态是否为100
              if (res[0].per === 100) {
                self.$notify({
                  title: '文件上传提示',
                  message: `${name}上传成功`,
                });
                // 从上传中列表中移除
                self.spliceElement(self.uploadingList, id);
                self.percentage.splice(index, 2);
                self.isUploading = false;
                setTimeout(() => self.refreshCurDeviceFileList(), 500);
              } else {
                self.$refs.fileTable.toggleRowSelection(self.curFileList[rowIndex]);
                setTimeout(() => circle(), 1000);
              }
            },
          );
      }

      // 第一次先延迟接口请求2秒，再函数内递归请求接口
      setTimeout(circle(), 2000);
    },

    // 测试代码
    uploadProgress(row) {
      const fileId = row.id;
      let isUpload = JSON.parse(JSON.stringify(this.isUploading));
      isUpload = true;
      this.setisUploading(isUpload);
      // this.isUploading = true;
      this.uploadProgressSubscription({ fileId });
    },
    // 测试代码


    // 获取对应文件名的上传进度
    getPercentage(name) {
      const index = this.percentage.indexOf(name);
      if (index > -1 && (typeof (this.percentage[index + 1])) === 'number') {
        return this.percentage[index + 1];
      }
      return 0;
    },

    checkFileListUpdate() {
      this.checkUpdate({ id: this.curDeviceData.id, name: this.curDeviceData.name })
        .then((success) => {
          if (this.getRefreshResult.success === true) {
            this.$confirm(`设备 ${this.getRefreshResult.name} 已完成文件列表刷新！  是否需要查看?`, '文件刷新提示', {
              confirmButtonText: '立即查看',
              cancelButtonText: '暂不查看',
              type: 'success',
            })
              .then(() => {
                this.$router.push('/');
                this.setSearchVal(this.getRefreshResult.name);
                this.setDeviceIndex(0);
                // 强制页面刷新，以强制device组件和appHeader组件刷新，以确保搜索栏内容和标题栏格式正确
                this.reload();
              });
          } else {
            this.$message({
              type: 'error',
              message: `设备 ${this.getRefreshResult.name} 文件列表刷新失败！
            错误码: ${this.getRefreshResult.errorCode}
            (${this.getRefreshResult.errorMsg.length === 0 ? '未知错误' : this.getRefreshResult.errorMsg})`,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showUploadFirmwareDialog() {
      this.uploadFirmwareToServerVisible = true;
      if (this.$refs.uploadFileCmp) {
        this.$refs.uploadFileCmp.clearFiles();
      }
    },
    showUploadFileDialog() {
      this.uploadFileToServerVisible = true;
      if (this.$refs.uploadFileCmp) {
        this.$refs.uploadFileCmp.clearFiles();
      }
    },
    handleFileCountExceed() {
      this.$message.warning('最多支持同时上传1个文件');
    },
    /**
       * 固件上传至服务器
       */
    uploadFirmware(uploadComponent) {
      deviceAPI.uploadFile(uploadComponent.file, this.curDeviceData.id)
        .then(() => {
          this.$message.success(`正在上传${uploadComponent.file.name},请稍候`);
        })
        .catch((err) => {
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          this.$message({
            type: 'error',
            message: `固件上传失败(${err[0]})：${err[1]}`,
          });
        });
    },
    uploadFirmwareToServerClick() {
      this.uploadFirmwareToServerVisible = false;
      this.refreshCurDeviceFileList();
    },
    /**
       * 文件上传至服务器
       */
    uploadFile(uploadComponent) {
      deviceAPI.uploadFile(uploadComponent.file, this.curDeviceData.id)
        .then(() => {
          this.$message.success(`正在上传${uploadComponent.file.name},请稍候`);
        })
        .catch((err) => {
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          this.$message({
            type: 'error',
            message: `文件上传失败(${err[0]})：${err[1]}`,
          });
        });
    },
    uploadFileToServerClick() {
      this.uploadFileToServerVisible = false;
      this.refreshCurDeviceFileList();
    },
    /**
       * 点击了上传服务器的按钮
       */
    uploadDeviceFileToServerClick(fileId) {
      console.debug(`把文件从设备上传服务器的按钮点击:fileId=${fileId}`);
      if (this.curDeviceData.networkStatus === this.DEVICE_NET_STATUS.FOURTH_G) {
        // 4G时需要弹框确认
        this.$confirm('当前在4G状态，上传服务器会产生流量费用，是否继续上传？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.uploadToServer(fileId);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消上传',
            });
          });
      } else {
        this.uploadToServer(fileId);
      }
    },
    downloadClick(fileId) {
      deviceAPI.downloadFileFromServer(fileId);
    },
    downloadToDeviceClick(fileId) {
      if (this.curDeviceData.networkStatus === this.DEVICE_NET_STATUS.FOURTH_G && this.fourGInformed === false) {
        // 4G时需要弹框确认
        this.$confirm('当前在4G状态，下发文件会产生流量费用，是否继续下发？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.downloadToDevice(fileId);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消上传',
            });
          });
      } else {
        this.fourGInformed = true;
        this.downloadToDevice(fileId);
      }
    },
    deleteFile(id) {
      this.$confirm('此操作将永久删除该文件，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 确认删除
          this.api_deleteFile({ id })
            .then(() => {
              this.$message({
                message: '删除成功！',
              });
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: '删除失败!',
              });
            });
        })
        .catch(() => {
          // 取消
          this.$message({
            type: 'info',
            message: '已取消删除操作',
          });
        });
    },

    /**
       * 把文件从设备上上传到服务器上
       * @param fileId 文件id
       */
    uploadToServer(fileId) {
      // 将原本对uploadingList的操作改为对vuex的操作
      const List = JSON.parse(JSON.stringify(this.uploadingList));
      List.push(fileId);
      this.setuploadingList(List);
      // this.uploadingList.push(fileId);
      deviceAPI.downloadFileToServer(fileId)
        .then(() => {
          this.$message.success('正在上传至服务器，请稍候...');
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    downloadToDevice(fileId) {
      deviceAPI.downloadToDevice(fileId)
        .then(() => {
          this.$message.success('正在等待设备响应，请稍候...');
          // TODO:(Qka, 2019/1/3) 增加对该文件的ws订阅
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
          // TODO:(Qka, 2019/1/3) 取消订阅
        });
    },
    dividePage(currentPage) {
      this.currentPage = currentPage;
    },
    startPlay(deviceId, canName) {
      const canIndex = canName.replace('CAN', '');
      deviceAPI.startCanPlay(deviceId, canIndex)
        .then(() => {
          this.$message.success('正在启动录制，等待设备响应，请稍候...');
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    stopPlay(deviceId, canName) {
      const canIndex = canName.replace('CAN', '');
      deviceAPI.stopCanPlay(deviceId, canIndex)
        .then(() => {
          this.$message('正在停止录制，等待设备响应，请稍候...');
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    setDeviceConfig(deviceId) {
      deviceAPI.setDeviceModel(deviceId, this.isDormancy, this.autoUploadFile, this.wfAutoUploadFile)
        .then(() => {
          this.$message.success('修改设备配置成功');
        })
        .catch((err) => {
          this.$message.error('修改设备配置err={}', err);
        });
    },
    /**
       * 判断是否为asc文件
       * @param name
       * @return {boolean}
       */
    isAsc(name) {
      return (name.indexOf('.asc') > -1);
    },
    /**
       * 将asc文件转为blf格式
       * @param fileId
       */
    changeFileAscToBlf(fileId) {
      const deviceId = this.curDeviceData.id;
      deviceAPI.changeAscToBlf(deviceId, fileId)
        .then(() => {
          this.$message('正在转化为blf格式，请稍候');
          this.refreshCurDeviceFileList();
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    saveOTAConfig(canIndex) {
      const self = this;
      const dllFileId = self.dllBindList[canIndex];
      const soFileId = self.soBindList[canIndex];
      const s19FileId = self.s19BindList[canIndex];
      if (dllFileId === undefined || soFileId === undefined || s19FileId === undefined) {
        self.$message.info('请完成OTA所有相关文件的绑定');
        return;
      }
      deviceAPI.saveOTAConfig(dllFileId, soFileId, s19FileId, canIndex, this.curDeviceData.id, this.OTABaudRate[canIndex])
        .then(() => {
          this.$message.success('OTA配置保存成功');
          this.getOTAConfig();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: `OTA配置保存失败(${err[0]})：${err[1]}`,
          });
        });
    },
    getOTAHistory(canIndex) {
      const self = this;
      deviceAPI.getOTAHistory(this.curDeviceData.id, canIndex)
        .then((res) => {
          self.otaHistory = res;
        })
        .catch((err) => {
          // self.otaHistory = [];
          this.$message({
            type: 'error',
            message: `OTA历史获取失败(${err[0]})：${err[1]}`,
          });
        });
    },
    startOTA() {
      const self = this;
      const deviceId = self.curDeviceData.id;
      // 可能需要修改
      if (this.selectedOTA.length === 0) {
        this.$message.info('请选择进行刷写的CAN通道');
      }
      // this.selectedOTA.map((item) => {
      // 由CAN通道的名字得到序号
      // });
      const index = this.selectedOTA.name.replace('CAN_', '');
      const otaId = self.otaIdList[index];
      if (otaId === undefined) {
        this.$message.error(`CAN${index}的OTA配置未保存，请保存后再试`);
      } else {
        // 将错误信息设为空后订阅错误消息
        this.setotaErrorMsg('');
        // this.otaErrorMsgSubscription({ deviceId, canIndex: index });
        deviceAPI.touchOffOTA(deviceId, otaId)
          .then(() => {
            // this.otaSubscription({ deviceId, canIndex: index });
            this.setOtaStatus(true);
            this.getOTAProgressData({ deviceId });
            this.$message.success(`CAN${index}的OTA已触发`);
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: `OTA启动失败(${err[0]})：${err[1]}`,
            });
          });
      }
    },
    getOTAConfig(Para) {
      console.log('获取配置');
      const deviceId = this.deviceId;
      console.log(Para);
      // watch里调用会找不到this.$refs.multipleTable.toggleAllSelection();，进而报错无法往下走
      if (Para !== 'watch' || Para === undefined) {
        this.$refs.multipleTable.toggleAllSelection();
      }
      deviceAPI.getOTAConfig(deviceId)
        .then((res) => {
          const otaConfigs = res.otaCanConfigs;
          console.log('ppp', otaConfigs);
          otaConfigs.map((item) => {
            const index = item.canIndex;
            this.s19BindList[index] = item.s19File.id;
            this.soBindList[index] = item.soFile.id;
            this.dllBindList[index] = item.dllFile.id;
            this.otaIdList[index] = item.otaId;
            this.OTABaudRate[index] = String(item.baudRate);
          });
          // 触发OTA表格的刷新
          this.$refs.multipleTable.clearSelection();
        })
        .catch((err) => {
          // this.$message.error('获取OTA配置不成功');
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.selectedOTA = val;
    },
    checkFileId(id, status) {
      // 检查是否在服务器上
      if (status === DEVICE_FILE_STATUS.ONSERVER) {
        return 0;
      }
      // 检查文件状态(是否为上传完毕)
      return this.uploadingList.indexOf(id) !== -1;
    },
    spliceElement(arr, element) {
      for (let i = 0; i < arr.length; i += 1) {
        try {
          if (arr[i] === element) {
            arr.splice(i, 1);
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    handleFileSelectionChange(val) {
      this.showBatchDelete = false;
      this.showBatchDownload = false;
      this.showBatchUpload = false;
      this.showBatchBlf = false;
      if (this.isUploading) {
        return;
      }
      console.log(val);
      this.multipleSelection = val;
      if (val.length > 0) {
        this.showBatchDownload = true;
        this.showBatchUpload = true;
        this.showBatchBlf = true;
        this.showBatchDelete = true;
        val.map((item) => {
          if (item.status !== 'ONSERVER') {
            this.showBatchDownload = false;
            this.showBatchBlf = false;
          } else if (item.status !== 'ONDEVICE') {
            this.showBatchUpload = false;
          }
          if (item.name.split('.')[1] !== 'asc') {
            this.showBatchBlf = false;
          }
        });
      }
    },
    batchConvertBLF() {
      this.$message.success(`正在转化${this.multipleSelection.length}个文件，请稍候...`);
      this.multipleSelection.map((item) => {
        deviceAPI.changeAscToBlf(this.curDeviceData.id, item.id)
          .catch((err) => {
            this.$message({
              type: 'error',
              message: `${item.name}转化失败, code=${err[0]}, reason=${err[1]}`,
            });
          });
      });
      this.$message.success(`成功转化${this.multipleSelection.length}个文件`);
      setTimeout(() => this.refreshCurDeviceFileList(), 1500);
    },
    batchDownload() {
      this.$message.success(`正在压缩${this.multipleSelection.length}个文件，请稍候...`);
      const idList = [];
      this.multipleSelection.map((item) => {
        idList.push(item.id);
      });
      deviceAPI.batchDownloadFileFromServer(idList)
        .then(res => deviceAPI.downloadZipFromServer(res))
        .catch((err) => {
          this.$message({
            type: 'error',
            message: `压缩失败, code=${err[0]}, reason=${err[1]}`,
          });
        });
    },
    batchDelete() {
      let success = true;
      const idList = [];
      this.$confirm(`批量删除${this.multipleSelection.length}个文件，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // this.multipleSelection.map((item) => {
          //   deviceAPI.deleteFile(item.id)
          //     .catch((err) => {
          //       success = false;
          //       this.$message({
          //         type: 'error',
          //         message: `${item.name}删除失败, code=${err[0]}, reason=${err[1]}`,
          //       });
          //     });
          // });
          this.multipleSelection.map((item) => {
            idList.push(item.id);
          });
          deviceAPI.deleteFile(idList)
            .catch((err) => {
              success = false;
              this.$message({
                type: 'error',
                message: `删除失败, code=${err[0]}, reason=${err[1]}`,
              });
            });
          if (success) {
            this.$message.success(`成功删除${this.multipleSelection.length}个文件`);
          }
          setTimeout(() => this.refreshCurDeviceFileList(), 500);
        })
        .catch(() => {
          // 取消
          this.$message({
            type: 'info',
            message: '已取消删除操作',
          });
        });
    },
    batchUpload() {
      this.percentage = [];
      this.$message.success(`正在批量上传${this.multipleSelection.length}个文件至服务器，请稍候...`);
      const idList = [];
      // const List = JSON.parse(JSON.stringify(this.uploadingList));
      this.multipleSelection.map((item) => {
        // const index = this.curFileList.findIndex(file => file.name === item.name);
        // List.push(item.id);
        // this.setuploadingList(List);
        // this.uploadingList.push(item.id);
        idList.push(item.id);
        // this.uploadStatus(item, index);
        // ws进度订阅 待测试-----------------------------------------------------
        // this.uploadProgress(item);
      });
      deviceAPI.batchDownloadToServer(idList)
        .then(() => {
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    // OTA进度取消订阅
    otaUnsub(deviceId) {
      if (this.getOTASuccess === false) {
        this.$message.error('OTA失败,', this.$store.getters.getOTAError);
        // this.otaUnsubscription(deviceId);
        // this.otaErrorMsgUnsubscription(deviceId);
      } else if (this.getOTAProgress === 100) {
        this.$message({
          message: 'OTA完成！',
          type: 'success',
        });
        // this.otaUnsubscription(deviceId);
        // this.otaErrorMsgUnsubscription(deviceId);
      }
    },
    // 文件上传进度取消订阅 待测试------------------------------------------------------
    uploadUnsub(fileId) {
      this.$message({
        message: '上传完成！',
        type: 'success',
      });
      // this.spliceElement(this.uploadingList, fileId);
      const List = JSON.parse(JSON.stringify(this.uploadingList));
      this.spliceElement(List, fileId);
      this.setuploadingList(List);
      let isUpload = JSON.parse(JSON.stringify(this.isUploading));
      isUpload = false;
      this.setisUploading(isUpload);
      // this.isUploading = false;
      setTimeout(() => this.refreshCurDeviceFileList(), 500);
      this.uploadProgressUnsubscription(fileId);
    },
    getFileUploadPercentage(fileId) {
      if (this.getFileUploadProgress.get(fileId) !== undefined) {
        const value = this.getFileUploadProgress.get(fileId) * 100;
        const res = parseFloat(value)
          .toFixed(1) * 1;
        // console.log('res= ', res);
        // console.log(typeof res);
        return Number(res);
      }
      return 0;
    },
    clearConditionConfig() {
      const deviceId = this.deviceId;
      deviceAPI.clearConditionConfig(deviceId)
        .catch((err) => {
          this.$message.error('条件判断配置清除失败！');
        });
    },
    setRocStatus(autoStart) {
      const deviceId = this.deviceId;
      deviceAPI.setRocStatus(deviceId, autoStart)
        .catch((err) => {
          this.$message.error('自启动录制配置更新失败！');
        });
    },
  },
  watch: {
    getDeviceConfig() {
      this.isDormancy = this.getDeviceConfig.unDormancy;
      this.autoUploadFile = this.getDeviceConfig.autoUploadFile;
      this.wfAutoUploadFile = this.getDeviceConfig.wfAutoUploadFile;
    },
    deviceId() {
      if (this.deviceId === undefined || this.deviceId === '') {
        return;
      }
      // 清空此前记录
      this.s19BindList = [];
      this.soBindList = [];
      this.dllBindList = [];
      this.otaIdList = [];
      // this.getOTAConfig();
      this.getOTAConfig('watch');
    },
    getOTAProgress() {
      this.otaUnsub(this.curDeviceData.id);
    },
    getOTASuccess() {
      this.otaUnsub(this.curDeviceData.id);
    },
    // 待测试-------------------------------------------------------------
    getFileUploadProgress() {
      for (const [key, value] of this.getFileUploadProgress) {
        if (value === 1) {
          this.uploadUnsub(key);
        }
      }
    },
  },
};


</script>

<style lang="scss" scoped>
  @import '../../style/media';
  @import '../../style/mixin';

  .warning-row {
    background: oldlace;
  }

  .success-row {
    background: #f0f9eb;
  }

  .deviceParameter {
    overflow: auto;

    .myplant, h2 {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #eee;
      font-size: 16px;
      color: #fff;
      text-shadow: 1px 1px 1px #3389e8;
      padding-left: 20px;
      line-height: 50px;
      font-weight: bold;
      background: linear-gradient(to top, rgba(51, 137, 232, 0.5), rgba(51, 137, 232, 0.7));
    }

    .myplant {
      border: 1px solid #eee;
    }

    .plantmiddel {
      background: #fff;
      padding: 0 20px 40px 20px;
      border: 1px solid #eee;
      border-top: none;

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          font-size: 14px;
          padding-top: 50px;
          width: 50%;
          @include min_1280 {
            width: 33.3%;
          }
        }
      }
    }

    .passageway, .configTable, .fota-file-list, .device-file-list {
      margin-top: 2%;
      border: 1px solid #eee;
      padding: 0;
      background: #fff;
    }

    .passage {
      padding: 20px;

      table {
      }
    }

    .config-table {
      width: 100%;

      thead {
        color: #909399;

        tr {
          height: 48px;
          line-height: 48px;

          th {
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }

      tbody {
        tr {
          height: 48px;
          line-height: 48px;

          td {
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }

    .upload-file-btn, .refresh-file-btn {
      position: relative;
      float: right;
      top: -40px;
      margin-right: 10px;

      &:hover {
        background: #fff;
        color: #3389e8;
      }

    }

    .file-list-table {
      padding: 20px;

      h3 {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        color: rgba(51, 137, 232, 0.8);
        line-height: 40px;
        font-weight: bold;

      }

      .progress-title {
        border-bottom: 0 !important;
      }

      .progress-bar {
        margin-bottom: 20px;
        display: block
      }

      .ecu-flash {
        margin-top: 20px;
      }

      .batch-button {
        float: left;
        margin: 5px 0;
      }

      .page-divided {
        float: right;
        margin: 5px 0;
      }

      .buttons {
        margin-right: 5px;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/device/deviceParameter.vue